
import { Component, Vue } from 'vue-property-decorator'
import GoodsList from "@/views/goodsManage/commodity/template/GoodsList.vue";
import GoodsResultCard from "@/views/goodsManage/mall/shop/template/GoodsResultCard.vue";
import { getGoodsList, GoodsListDto } from "@/api/commodity";
import { Getter } from "vuex-class";
import { addSearchHistory } from '@/api/shoppingMall';
import SearchNav from "@/components/SearchNav/index.vue";

@Component({
  components: { SearchNav, GoodsResultCard, GoodsList }
})
export default class SearchGoods extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string

  goodsList: GoodsListDto[] = []
  params = {

    keyword: ''
  }

  created () {
    this.params.keyword = this.$route.query.keyword as string
    this.$nextTick(() => {
      this.searchFunc(this.params.keyword)
    })
  }

  // getGoodsList () {
  //   getGoodsList(this.params).then((res) => {
  //     this.goodsList = res.data.records || []
  //   })
  // }

  searchFunc (keyword: string) {
    if(this.$checkIsEmpty(keyword)) return false;
    (this.$refs.goodsList as GoodsList).filterKeyword(keyword)
    addSearchHistory({
      searchType: 3,
      keyword,
      customerId: this.companyId,
      providerId: this.companyId
    })
  }

}
